import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { adminApi, getToken, setToken } from "./adminApi";

const RequireAdmin = ({ children }) => {
  const [state, setState] = useState({ checking: true, ok: false });

  useEffect(() => {
    if (!getToken()) {
      setState({ checking: false, ok: false });
      return;
    }
    adminApi
      .me()
      .then(() => setState({ checking: false, ok: true }))
      .catch(() => {
        setToken(null);
        setState({ checking: false, ok: false });
      });
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen bg-canvas text-ink flex items-center justify-center">
        <p className="text-[11px] tracking-[0.3em] uppercase text-ink/60">
          Loading…
        </p>
      </div>
    );
  }

  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return children;
};

export default RequireAdmin;
